<template>
  <div>
    <!-- Affiliate Bar -->
    <div class="ecpl-aff-bar">
      <div class="ecpl-aff-bar__container">
        <span class="ecpl-aff-bar__label">Our Affiliate Leagues:</span>
        <ul class="ecpl-aff-bar__links">
          <li>
            <a
              href="/"
              class="ecpl-aff-bar__link ecpl-aff-bar__link--active"
            >ECPL</a>
          </li>
          <li>
            <a
              href="https://www.ukpl.co.uk/"
              target="_blank"
              class="ecpl-aff-bar__link"
            >CPPS</a>
          </li>
        </ul>
      </div>
    </div>
    <!-- Main Nav -->
    <nav class="ecpl-nav">
      <div class="ecpl-nav__container">
        <div class="ecpl-nav__logo-link-wrap">
          <router-link to="/">
            <div class="ecpl-nav__logo-wrap">
              <img
                class="ecpl-nav__logo"
                src="@/assets/ECPL.png"
                alt="ECPL Logo"
              >
            </div>
          </router-link>
        </div>
      </div>
      <div
        v-if="currentUser"
        class="ecpl-nav__links-container"
      >
        <div class="ecpl-nav__link-wrap">
          <router-link
            v-if="isAdmin"
            class="ecpl-nav__link"
            to="/players"
          >
            Players
          </router-link>
          <router-link
            v-if="isAdmin"
            class="ecpl-nav__link"
            to="/teams"
          >
            Teams
          </router-link>
          <router-link
            v-if="isAdmin"
            class="ecpl-nav__link"
            to="/scores"
          >
            Score Entry
          </router-link>
          <router-link
            v-if="isAdmin"
            class="ecpl-nav__link"
            to="/rounds"
          >
            Round Management
          </router-link>
          <router-link
            v-if="isAdmin"
            class="ecpl-nav__link"
            to="/signin"
          >
            Sign In
          </router-link>
        </div>
        <div class="ecpl-nav__cta-link-wrap">
          <a
            class="ecpl-nav__cta-link"
            href="#"
            @click.prevent="logOut"
          >
            <v-icon
              small
              color="white"
              class="mr-1"
            >
              fa-sign-out-alt
            </v-icon>
            Logout
          </a>
        </div>
      </div>
      <div
        v-else
        class="ecpl-nav__links-container"
      >
        <span class="ecpl-nav__welcome">Welcome to ECPL Admin</span>
      </div>
      <!-- Mobile hamburger -->
      <div
        class="ecpl-nav__burger hidden-md-and-up"
        @click="$emit('toggleDrawer')"
      >
        <v-icon color="white">
          mdi-menu
        </v-icon>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'UkplMenu',
  props: {
    currentUser: { type: Object, default: null },
    isAdmin: { type: Boolean, default: false },
    menuClass: { type: String, default: '' },
    logOut: { type: Function, default: null }
  }
};
</script>

